<div class="d-flex align-items-center justify-content-center vh-65">
  <app-document-verification-form class="p-5"> </app-document-verification-form>
</div>
